// Indonesian formatting helpers

export const formatRupiah = (amount) => {
  const n = Math.round(Number(amount) || 0);
  const formatted = n.toLocaleString("id-ID");
  return `Rp. ${formatted},-`;
};

export const parseRupiah = (str) => {
  if (typeof str === "number") return str;
  return Number(String(str || "").replace(/[^\d-]/g, "")) || 0;
};

const MONTHS_ID = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export const formatDateID = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return `${d.getDate()} ${MONTHS_ID[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatDateShort = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
};

export const toInputDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const STATUS_LABEL = {
  masuk: "Order Masuk",
  proses: "Proses Pengerjaan",
  selesai: "Selesai Dikerjakan",
  diterima: "Diterima Customer",
};

export const STATUS_ORDER = ["masuk", "proses", "selesai", "diterima"];
